import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/plat-montior',
  name: 'plat-montior',
  component: () => import('../views/v2/index.vue')
  }, {
    path: '/plat-montior/car',
    name: 'v2carindex',
    component: () => import('../views/v2/car-index.vue')
  }, {
    path: '/plat-montior/bicycle',
    name: 'v2bicycleindex',
    component: () => import('../views/v2/bicycle-index.vue')
  }, {
    path: '/plat-montior/control',
    name: 'v2controlindex',
    component: () => import('../views/v2/control-index.vue')
  }, {
    path: '/plat-montior/control/list',
    name: 'v2controllist',
    component: () => import('../views/v2/control-list.vue')
  }, {
    path: '/plat-montior/camera',
    name: 'v2controllist',
    component: () => import('../views/v2/camera.vue')
  },
  // 平台虚拟镜像
  {
    path: '/mirror/plat-montior',
    name: 'mirror-plat-montior',
    component: () => import('../views/v2/index.vue')
  }, {
    path: '/mirror/plat-montior/car',
    name: 'mirror-v2carindex',
    component: () => import('../views/v2/car-index.vue')
  }, {
    path: '/mirror/plat-montior/bicycle',
    name: 'mirror-v2bicycleindex',
    component: () => import('../views/v2/bicycle-index.vue')
  }, {
    path: '/mirror/plat-montior/control',
    name: 'mirror-v2controlindex',
    component: () => import('../views/v2/control-index.vue')
  }, {
    path: '/mirror/plat-montior/control/list',
    name: 'mirror-v2controllist',
    component: () => import('../views/v2/control-list.vue')
  }, {
    path: '/mirror/plat-montior/camera',
    name: 'mirror-v2controllist',
    component: () => import('../views/v2/camera.vue')
  },
  // 品牌大屏路由
  {
    path: '/merchant',
    name: 'v2merchantindex',
    component: () => import('../views/v2/merchant/index.vue')
  }, {
    path: '/merchant/car',
    name: 'v2merchantcarindex',
    component: () => import('../views/v2/merchant/car-index.vue')
  }, {
    path: '/merchant/bicycle',
    name: 'v2merchantbicycleindex',
    component: () => import('../views/v2/merchant/bicycle-index.vue')
  }, {
    path: '/merchant/control',
    name: 'v2-merchant-controlindex',
    // component: () => import('../views/v2/control-index.vue')
    component: () => import('../views/v2/camera.vue')
  },{
    path: '/merchant/control/list',
    name: 'v2-merchant-controllist',
    component: () => import('../views/v2/control-list.vue')
  },
  //品牌大屏路由镜像
  {
    path: '/mirror/merchant',
    name: 'mirror-v2merchantindex',
    component: () => import('../views/v2/merchant/index.vue')
  }, {
    path: '/mirror/merchant/car',
    name: 'mirror-v2merchantcarindex',
    component: () => import('../views/v2/merchant/car-index.vue')
  }, {
    path: '/mirror/merchant/bicycle',
    name: 'mirror-v2merchantbicycleindex',
    component: () => import('../views/v2/merchant/bicycle-index.vue')
  }, {
    path: '/mirror/merchantr/control',
    name: 'mirror-v2-merchant-controlindex',
    // component: () => import('../views/v2/control-index.vue')
    component: () => import('../views/v2/camera.vue')
  }, {
    path: '/mirror/merchant/control/list',
    name: '/mirror-v2-merchant-controllist',
    component: () => import('../views/v2/control-list.vue')
  }, {
    path: '/error',
    name: 'error',
    component: () => import('../views/error.vue')
  }, {
    path: '/mainscreen',
    name: 'mainscreen',
    component: () => import('../views/main-screen.vue')
  }, {
    path: '/merchant',
    name: 'merchant',
    component: () => import('../views/merchant-screen.vue')
  }, {
    path: '/index',
    name: 'index',
    component: () => import('../views/index.vue')
  }, {
    path: '/density',
    name: 'density',
    component: () => import('../views/index-density.vue')
  }, {
    path: '/flash',
    name: 'flash',
    component: () => import('../views/index-flash.vue')
  }, {
    path: '/province',
    name: 'province',
    component: () => import('../views/index-province-density.vue')
  }, {
    path: '/datav',
    name: 'datav',
    component: () => import('../views/index-datav-demo.vue')
}]
const router = new VueRouter({
  mode: "hash",
  routes
})

export default router
